<template>
    <v-dialog
        v-model="dialog"
        max-width="500"
    >
        <v-card>
            <v-card-title class="headline zoezi-edit-color">
                {{ $translate(duplicate ? 'Duplicate page' : 'Create new page') }}
                <v-btn icon @click="dialog = false" class="ml-auto zoezi-edit-color"><v-icon>mdi-close</v-icon></v-btn>
            </v-card-title>

            <v-card-text class="pt-4">
                <v-text-field :label="$translate('Title')" v-model="title" @input="updateNewPageLink()" color="zoezi-edit-color" />
                <v-text-field :label="$translate('Path')" v-model="path" color="zoezi-edit-color" />

                <page-template-palette v-model="newPage" v-if="!duplicate" />
            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>

                <v-btn
                    color="zoezi-edit-color"
                    @click="addPage"
                    :disabled="!validNewPage"
                >
                    {{ $translate(duplicate ? 'Duplicate page' : 'Create new page') }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import PageTemplatePalette from '../components/PageTemplatePalette.vue'
import components from '../component.js';
import {addRoute} from '../router.js'
import {isValidPath, makeValidPathFromTitle} from '../util.js'
export default {
    name: 'zoezi-addpage',

    components: {
        PageTemplatePalette
    },

    props: ['value', 'duplicate'],

    watch: {
        value: {
            immediate: true,
            handler() {
                this.dialog = this.value;
                if (this.value) {
                    this.title = this.$translate('New page')
                    this.path = '/' + this.title.replace(' ', '').toLowerCase();
                }
            }
        },
        dialog() {
            this.$emit('input', this.dialog);
        }
    },

    data: () => ({
        dialog: true,
        title: 'New page',
        path: '/newpage',
        newPage: {}
    }),

    computed: {
        normalizedNewPage() {
            let v = this.path;
            if (v && !v.startsWith('/')) {
                v = '/' + v;
            }
            return v;
        },
        validNewPage() {
            return !!(this.title.length && this.normalizedNewPage && isValidPath(this.normalizedNewPage) && ((!this.$root.siteconfig.routes.find(x => x.props.path == this.normalizedNewPage) && (this.duplicate || (this.newPage.config && this.newPage.config.component)))))
        }
    },

    methods: {
        updateNewPageLink() {
            this.path = makeValidPathFromTitle(this.title);
        },
        addPage() {
            let config = this.duplicate ? this.$root.siteconfig.routes.find(x => x.props.path == this.$route.path) : this.newPage.config;
            config = Object.assign({}, config);

            config = components.makeEmptyConfig({component: 'zoezi-page', props: {config: config, name: this.title, path: this.normalizedNewPage, showInGoogle: 50}})
            addRoute(config, this.$router);

            this.$root.siteconfig.routes.push(config);
            this.$root.saveHomePage();
            this.$router.push({path: this.normalizedNewPage});

            this.dialog = false;
        }
    }
}
</script>
